import { BrowserRouter as Router, Switch } from "react-router-dom";
import GeustRoute from "./helpers/authentication/geustRoute";
import Layout from "./components/layout/Layout";
import AuthRoute from "./helpers/authentication/authRoute";
import Login from "./views/authentication/Login";
import Home from "./views/Home";
import ModeratorsIndex from "./views/moderators/ModeratorsIndex";
import ModeratorsCreate from "./views/moderators/ModeratorsCreate";
import ModeratorShow from "./views/moderators/ModeratorShow";

import RealEstateIndex from "./views/realEstate/RealEstateIndex";
import RealEstateCreate from "./views/realEstate/RealEstateCreate";
import RealEstateShow from "./views/realEstate/RealEstateShow";

import CategoriesIndex from "./views/category/CategoriesIndex";
import CategoriesCreate from "./views/category/CategoriesCreate";
import CategoriesShow from "./views/category/CategoriesShow";

import TypeIndex from "./views/apartmentType/TypeIndex";
import TypeCreate from "./views/apartmentType/TypeCreate";
import TypeShow from "./views/apartmentType/TypeShow";

import ServicesApplications from "./views/services/ServicesApplications";
import ServiceShowApplication from "./views/services/ServiceShowApplication";

import ContactIndex from "./views/contact/ContactIndex";
import ContactShow from "./views/contact/ContactShow";
import SliderIndex from "./views/slider/SliderIndex";
import SliderCreate from "./views/slider/SliderCreate";
import SliderShow from "./views/slider/SliderShow";

// import LinksIndex from "./views/footerLinks/LinksIndex";
// import LinksCreate from "./views/footerLinks/LinksCreate";
// import LinksShow from "./views/footerLinks/LinksShow";

// import About from "./views/About";
import Settings from "./views/Settings";

import CommentsIndex from "./views/Comments/CommentsIndex";
import CommentsCreate from "./views/Comments/CommentsCreate";
import CommentsShow from "./views/Comments/CommentsShow";
import HeroSectionIndex from "./views/heroSection/HeroSectionIndex";
import HeroSectionCreate from "./views/heroSection/HeroSectionCreate";
import HeroSectionShow from "./views/heroSection/HeroSectionShow";
import AboutUsIndex from "./views/aboutPage/AboutUsIndex";
import AboutUsShow from "./views/aboutPage/AboutUsShow";
import WhyUsShow from "./views/whyUs/WhyUsShow";
import WhyUsIndex from "./views/whyUs/WhyUsIndex";
import LinksCreate from "./views/socials/links/LinksCreate";
import LinksIndex from "./views/socials/links/LinksIndex";
import LinksShow from "./views/socials/links/LinksShow";

import SocialTypes from "./views/socials/types/SocialTypesIndex";
import SocialTypesCreate from "./views/socials/types/SocialTypesCreate";
import SocialTypesShow from "./views/socials/types/SocialTypesShow";

import SeoRedirectsIndex from "./views/seoRedirects/SeoRedirectsIndex";
import SeoRedirectsCreate from "./views/seoRedirects/SeoRedirectsCreate";
import SeoRedirectsShow from "./views/seoRedirects/SeoRedirectsShow";

function App() {
	return (
		<Router>
			<Switch>
				<GeustRoute path="/login" component={Login} />
				<Layout>
					<AuthRoute path="/" exact component={Home} />
					<AuthRoute path="/dashboard" component={Home} />
					<AuthRoute path="/moderators/index" component={ModeratorsIndex} />
					<AuthRoute path="/moderators/create" component={ModeratorsCreate} />
					<AuthRoute
						path="/moderators/show/:moderatorID"
						component={ModeratorShow}
					/>
					<AuthRoute path="/category/index" component={CategoriesIndex} />
					<AuthRoute path="/category/create" component={CategoriesCreate} />
					<AuthRoute
						path="/category/show/:categoryId"
						component={CategoriesShow}
					/>
					<AuthRoute
						path="/social/socialType/index"
						component={SocialTypes}
						exact
					/>
					<AuthRoute
						path="/social/socialType/create"
						component={SocialTypesCreate}
						exact
					/>
					<AuthRoute
						path="/social/socialType/show/:linkId"
						component={SocialTypesShow}
						exact
					/>
					<AuthRoute path="/social/links/index" component={LinksIndex} />
					<AuthRoute path="/social/links/create" component={LinksCreate} />
					<AuthRoute path="/social/links/show/:linkId" component={LinksShow} />
					<AuthRoute path="/apartmentType/index" component={TypeIndex} />
					<AuthRoute path="/apartmentType/create" component={TypeCreate} />
					<AuthRoute path="/apartmentType/show/:typeId" component={TypeShow} />

					<AuthRoute path="/realestate/index" component={RealEstateIndex} />
					<AuthRoute path="/realestate/create" component={RealEstateCreate} />
					<AuthRoute
						path="/realestate/show/:realEstateId"
						component={RealEstateShow}
					/>
					<AuthRoute
						path="/services/applications"
						component={ServicesApplications}
					/>
					<AuthRoute
						path="/services/application/:applicationID"
						component={ServiceShowApplication}
					/>
					<AuthRoute path="/orders/index" component={ContactIndex} />
					<AuthRoute path="/orders/show/:contactID" component={ContactShow} />
					<AuthRoute path="/settings" component={Settings} />
					<AuthRoute path="/slider/index" component={SliderIndex} />
					<AuthRoute path="/slider/create" component={SliderCreate} />
					<AuthRoute path="/slider/show/:slideID" component={SliderShow} />
					<AuthRoute path="/footerLinks/index" component={LinksIndex} />
					<AuthRoute path="/footerLinks/create" component={LinksCreate} />
					{/* <AuthRoute path="/footerLinks/show/:linkID" component={LinksShow} /> */}
					{/* Comments Section */}
					<AuthRoute path="/Comments/index" component={CommentsIndex} />
					<AuthRoute path="/Comments/create" component={CommentsCreate} />
					<AuthRoute path="/Comments/show/:centerID" component={CommentsShow} />
					{/* Comments End Here */}
					<AuthRoute
						path="/siteinfo/heroSection/create"
						component={HeroSectionCreate}
					/>
					<AuthRoute
						path="/siteinfo/heroSection/index"
						component={HeroSectionIndex}
					/>
					<AuthRoute
						path="/siteinfo/heroSection/show/:heroSectionId"
						component={HeroSectionShow}
					/>
					{/* <AuthRoute
						path="/siteinfo/aboutUs/create"
						component={AboutUsCreate}
					/> */}
					<AuthRoute path="/siteinfo/aboutUs/index" component={AboutUsIndex} />
					<AuthRoute
						path="/siteinfo/aboutUs/show/:aboutUsSectionId"
						component={AboutUsShow}
					/>
					<AuthRoute path="/siteinfo/whyUs/index" component={WhyUsIndex} />

					<AuthRoute
						path="/siteinfo/whyUs/show/:whyUsId"
						component={WhyUsShow}
					/>
					<AuthRoute path="/seoRedirects/index" component={SeoRedirectsIndex} />
					<AuthRoute path="/seoRedirects/create" component={SeoRedirectsCreate} />
					<AuthRoute path="/seoRedirects/show/:redirectID" component={SeoRedirectsShow} />
				</Layout>
			</Switch>
		</Router>
	);
}

export default App;
